<template>
    <div class="catalog-pager">
        <div v-if="$slots.left" class="catalog-pager__left">
            <slot name="left" />
        </div>
        <div v-if="$slots.default" class="catalog-pager__center">
            <slot />
        </div>

        <div class="catalog-pager__right">
            <slot name="right" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'CatalogPager'
}
</script>
<style scoped lang="scss">
.catalog-pager {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;
    min-height: 72px;
    background-color: $gray-light;

    @media #{$media-to-sm} {
        min-height: 0;
        flex-direction: column;
        align-items: normal;
    }

    &__left {
        display: flex;
        align-items: center;
        padding: 16px 8px;

        @media #{$media-to-sm} {
            padding: 0 8px;
            min-height: 50px;
            height: 50px;
        }
    }

    &__center {
        margin: 0 auto;

        @media #{$media-to-sm} {
            width: 100%;
            order: 3;
        }
    }

    &__right {
        margin-left: auto;
        align-self: stretch;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 8px;
        gap: 8px;

        &:before {
            content: '';
            padding-right: 8px;
            border-left: 1px solid #cee7d8;
            height: 40px;
        }

        @media #{$media-to-sm} {
            width: 100%;
            height: 50px;
            padding-right: 8px;
            justify-content: flex-end;
            border-top: 1px solid #d2d4dc;

            &:before {
                display: none;
            }
        }
    }
}
</style>
